<script lang="ts" setup>
import { ref, computed, onMounted } from 'vue'
import BKUserSelect from '@/components/BKUserSelect.vue'
import { Studio, StudioUser, SearchParams } from '@/modules/Studios/types'
import { StudioApi } from '@/enitites/studio'

const props = defineProps<{
  studio: Studio
}>()

const teachers = ref<StudioUser[]>([])
const paginationParams = ref<SearchParams>({
  pageNumber: 0,
  pageSize: 100,
})

// Computed properties
const excludedTeacherIds = computed(() => teachers.value.map((teacher) => teacher.id))

// Teachers methods
const fetchTeachers = async () => {
  if (!props.studio) return
  teachers.value = await StudioApi.fetchStudioTeachers(props.studio.id, paginationParams.value)
}

const addTeacher = async (user: StudioUser) => {
  if (!props.studio) return
  const resp = await StudioApi.addStudioTeacher(props.studio.id, user.id)
  if (resp) {
    teachers.value.push(user)
  }
}

const removeTeacher = async (user: StudioUser) => {
  if (!props.studio) return
  const resp = await StudioApi.deleteStudioTeacherById(props.studio.id, user.id)
  if (resp) {
    teachers.value = teachers.value.filter((teacher) => teacher.id !== user.id)
  }
}

onMounted(async () => {
  await fetchTeachers()
})
</script>

<template>
  <div class="studio-teachers">
    <p class="teachers-title">Add teachers</p>
    <!--      eslint-disable vuejs-accessibility/aria-role-->
    <BKUserSelect
      :exclude="excludedTeacherIds"
      :select-user-chip="teachers"
      label-text="Find teachers to add"
      role="teacher"
      @removeUser="removeTeacher"
      @selectUser="addTeacher"
    />
    <!--      eslint-enable vuejs-accessibility/aria-role-->
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/style/mixins';

.studio-teachers {
  width: 100%;
  min-height: 500px;
}

.teachers-title {
  margin: 12px 0;
  color: var(--color-dark-800);
}
</style>
